export const METRICS_HEADER = {
  ARIA_LABEL_APPLIED_FILTERS: "Applied Filters",
  MENU_TITLE: "Applied Filters",
  MENU_SELECTED_FILTERS_HEADER_KEY: "selectedFiltersHeader",
  MENU_SELECTED_FILTERS_HEADER_TEXT: "Selected Filters",
  MENU_SELECTED_FILTERS_CONTEXT_KEY: "selectedFiltersContext",
  ICON_CLEAR_FILTER: "ClearFilter",
  TOOLTIP_CLEAR_ALL: "Clear all filters by clicking here.",
  TOOLTIP_FILTERS_IN_USE: "Filters already in use"
};
